import { render, staticRenderFns } from "./InnerWelcomeBannerComponent.vue?vue&type=template&id=26c2ec5d"
import script from "./InnerWelcomeBannerComponent.vue?vue&type=script&lang=js"
export * from "./InnerWelcomeBannerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports